import { v4 as uuidv4 } from "uuid";

function chillHop() {
  return [
    {
      name: "Ignite",
      artist: "Alan Walker, Julie Bergan, K-391",
      cover:
        "https://c.saavncdn.com/014/Ignite-English-2018-20180615143214-500x500.jpg",
      audio:
        "https://aac.saavncdn.com/014/5a1c76a6977a2aab6e5bfcc1adbe029f_160.mp4",
      id: uuidv4(),
      active: true,
      color: ["#8c2906", "#4a231d"],
    },
    {
      name: "Lonely",
      artist: "Akon",
      cover:
        "https://i.discogs.com/bmSb2lZHEtKfriGnQIY2TGwKvGaVpG03pQPMXK5oAj8/rs:fit/g:sm/q:40/h:300/w:300/czM6Ly9kaXNjb2dz/LWRhdGFiYXNlLWlt/YWdlcy9SLTE2MTUx/NDMwLTE2MDQ0NzEy/MjUtNDY3Ni5qcGVn.jpeg",
      audio:
        "https://aac.saavncdn.com/909/5e5a143974d597fad1e450aa6faf93ad_160.mp4",
      id: uuidv4(),
      active: false,
      color: ["#837461", "#5e4727"],
    },
    {
      name: "Naatu Naatu",
      artist: "Rahul Sipligunj, Kaala Bhairava",
      cover:
        "https://c.saavncdn.com/683/Rrr-Telugu-2022-20220416081038-500x500.jpg",
      audio:
        "https://aac.saavncdn.com/683/48280126306f820c18fac255d2616865_160.mp4",
      id: uuidv4(),
      active: false,
      color: ["#7b6c65", "#e09a65"],
    },
    {
      name: "Hawayein",
      artist: "Pritam, Arijit Singh",
      cover:
        "https://c.saavncdn.com/584/Jab-Harry-Met-Sejal-Hindi-2017-20170803161007-500x500.jpg",
      audio:
        "https://aac.saavncdn.com/584/1c4f10826f2336b0cb7db275f1051f8c_160.mp4",
      id: uuidv4(),
      active: false,
      color: ["#c9b640", "#725034"],
    },
    {
      name: "The Spectre",
      artist: "Alan Walker",
      cover:
        "https://c.saavncdn.com/532/The-Spectre-English-2017-20170831185520-500x500.jpg",
      audio:
        "https://aac.saavncdn.com/532/b84681ac81c18c5f2ec5eb9a991dd688_160.mp4",
      id: uuidv4(),
      active: false,
      color: ["#4d6994", "#223440"],
    },
    {
      name: "Alone",
      artist: "Alan Walker",
      cover:
        "https://c.saavncdn.com/522/Alone-English-2017-20180131085202-500x500.jpg",
      audio:
        "https://aac.saavncdn.com/522/cc62bd3e274e8d8b1a54c27c70ada512_160.mp4",
      id: uuidv4(),
      active: false,
      color: ["#b8b8b8", "#404f4e"],
    },
    {
      name: "Why we loose",
      artist: " NCS ",
      cover: "https://c.saavncdn.com/041/Why-We-Lose-English-2015-500x500.jpg",
      audio:
        "https://aac.saavncdn.com/041/424e5db611f1034dadff15a8b771cb64_160.mp4",
      id: uuidv4(),
      active: false,
      color: ["#5aabc3", "#323232"],
    },
    {
      name: "Dark Side",
      artist: "Alan Walker, Au/Ra, Tomine Harket",
      cover:
        "https://c.saavncdn.com/355/Darkside-English-2018-20180719130414-500x500.jpg",
      audio:
        "https://aac.saavncdn.com/355/5eed3326fb2aa459d06b5ce97f51f368_160.mp4",
      id: uuidv4(),
      active: false,
      color: ["#a9d9d3", "#0d161d"],
    },
    {
      name: "Know by Now",
      artist: "Idealism, SwuM",
      cover:
        "https://chillhop.com/wp-content/uploads/2022/07/e4292fd3128da3eb44c528641e120ab67be129a9-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=43680",
      id: uuidv4(),
      active: false,
      color: ["#233d67", "#ad886f"],
    },
    {
      name: "See You Cross Country",
      artist: "Aviino",
      cover:
        "https://chillhop.com/wp-content/uploads/2023/04/a32d2ec47ba20c985c2b2425fd24d277a8f36d3e-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=55315",
      id: uuidv4(),
      active: false,
      color: ["#e5e5bf", "#191d20"],
    },
    {
      name: "Cabriolet",
      artist: " Plusma, Ben Bada Boom ",
      cover:
        "https://chillhop.com/wp-content/uploads/2023/02/492202568b0d18312224043686735f7f1a47f67b-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=49369",
      id: uuidv4(),
      active: false,
      color: ["#b9ab48", "#bdecf7"],
    },
    {
      name: "Balcony",
      artist: "Shofel",
      cover:
        "https://chillhop.com/wp-content/uploads/2023/05/a553b95f790409f69feabdd6279f1153a11f14b3-1024x1024.jpg",
      audio: "https://mp3.chillhop.com/serve.php/?mp3=58853",
      id: uuidv4(),
      active: false,
      color: ["#873f27", "#767468"],
    },
  ];
}
export default chillHop;
